import { render, staticRenderFns } from "./Oferta.vue?vue&type=template&id=3752c2bc&scoped=true"
import script from "./Oferta.vue?vue&type=script&lang=js"
export * from "./Oferta.vue?vue&type=script&lang=js"
import style0 from "./Oferta.vue?vue&type=style&index=0&id=3752c2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3752c2bc",
  null
  
)

export default component.exports